// @ts-nocheck

import palette from '../palette';

export const Legal = {
  color: palette.white,
  DE: {
    svgBackground: palette.greyfooter,
  },
  pagination: {
    color: palette.neutralgrey450,
    bulletColor: palette.white,
  },
};
